export var SubmissionResultStatusType;

(function (SubmissionResultStatusType) {
  SubmissionResultStatusType["Passed"] = "10";
  SubmissionResultStatusType["Failed"] = "11";
})(SubmissionResultStatusType || (SubmissionResultStatusType = {}));

export var handleSubmissionResultStatusColor = function handleSubmissionResultStatusColor(resultStatus) {
  switch (resultStatus) {
    case SubmissionResultStatusType.Passed:
      return 'success';

    case SubmissionResultStatusType.Failed:
      return 'error';

    default:
      return 'default';
  }
};